import classNames from "classnames";
import React from "react";

import { Badge } from "./Badge";

type Props = {
  className?: string;
};

export function OnCallBadge({ className }: Props) {
  return (
    <Badge
      title="On-Call"
      size="sm"
      colourOverride="bg-primary-dark text-white border border-warning-light"
      className={classNames("tracking-wide", className)}
    >
      On-Call
    </Badge>
  );
}
